import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-fileupload',
  templateUrl: './fileupload.component.html',
  styleUrls: ['./fileupload.component.css']
})

export class FileuploadComponent implements OnInit {

  @Output() private eventFile = new EventEmitter<File>();

  @Input() url: string;

  @Input() value: string;

  @Input() editing: boolean;

  imgToupload: string;

  image: File;

  constructor() { }

  ngOnInit() {
  }

  OnDestroy() {

  }

  chargeFile(event: any, tag: any) {

    const file = event.target.files[0];
    if (!file) {
      this.imgToupload = null;
      return;
    }
    if (file.type.indexOf('image') < 0) {
      Swal.fire('Sólo imágenes!', 'El archivo seleccionado no es una imagen.', 'error');
      this.imgToupload = null;
      return;
    }

    const reader = new FileReader();
    const urlImgTemp = reader.readAsDataURL(file);

    reader.onloadend = () => {
      this.imgToupload = reader.result.toString();
      this.eventFile.emit(file);
    };
  }

}

